export default __webpack_public_path__ + "static/media/Dosis-Semibold.3580e72c.ttf";